import {
  PARAM_ENTITY_ID,
  PARAM_HEADQUARTER_ID,
  PARAM_OFFER_ID,
  RouteAction,
  RouteEntity,
  RouteError,
  RouteOutletAction,
  RouteParam,
} from './route.model';

export const EMPTY_PATH = '';
export type EMPTY_PATH = typeof EMPTY_PATH;

export const BACK_PATH = '..';
export type BACK_PATH = typeof BACK_PATH | '../..' | '../../..' | '../../../..' | '../../../../..';

export const START_URL_ABSOLUTE_PATH = '/' as const;
export type START_URL_ABSOLUTE_PATH = typeof START_URL_ABSOLUTE_PATH;

export interface RouteOutlet {
  outlets: {
    popup: null | RouteOutletAction;
  };
}

export type StaticPathRouter =
  | RouteEntity
  | RouteAction
  | RouteParam
  | `${RouteEntity}/${RouteAction}`
  | EMPTY_PATH
  | START_URL_ABSOLUTE_PATH
  | RouteError;
export type PathRouter = StaticPathRouter | number | RouteOutlet | BACK_PATH | string | undefined;

export type Path =
  | EMPTY_PATH
  | RouteEntity
  | RouteAction
  | RouteError
  | RouteParam
  | `${RouteParam}/${RouteAction}`
  | `${RouteEntity}/${RouteAction}`
  | '**';

const replaceUrlParam = (param: RouteParam, offerId?: number, entityId?: number | string): PathRouter => {
  switch (param) {
    case PARAM_OFFER_ID:
      return offerId ?? param;
    case PARAM_ENTITY_ID:
      return entityId ?? param;
    default:
      return param;
  }
};

const isRouteParam = (path: StaticPathRouter): path is RouteParam =>
  path === PARAM_OFFER_ID || path === PARAM_HEADQUARTER_ID || path === PARAM_ENTITY_ID;

export const replaceUrl = (urls: StaticPathRouter[], offerId?: number, entityId?: number | string): PathRouter[] =>
  urls.map((path) => (isRouteParam(path) ? replaceUrlParam(path, offerId, entityId) : path));
